module.exports = __webpack_public_path__ + "static/media/speech_05.c67067d9.png";